var _path, _path2, _path3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg028Onlinebusiness(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bold",
    enableBackground: "new 0 0 32 32",
    height: 512,
    viewBox: "0 0 32 32",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m26 32h-20c-3.314 0-6-2.686-6-6v-20c0-3.314 2.686-6 6-6h20c3.314 0 6 2.686 6 6v20c0 3.314-2.686 6-6 6z",
    fill: "#e3f8fa"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m15 12.167v-2.817c-.056-.005-.11-.017-.167-.017h-5.666c-.644 0-1.167.524-1.167 1.167v5c0 .184.102.354.264.441.074.039.155.059.236.059.096 0 .193-.028.277-.083l1.673-1.111c.131-.09.293-.139.458-.139h3.926c.529 0 1.002-.228 1.337-.587-.693-.363-1.171-1.08-1.171-1.913z",
    fill: "#26c6da"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m23.5 14.667c-.097 0-.193-.028-.277-.084l-1.664-1.109c-.137-.092-.297-.14-.462-.14h-3.93c-.643 0-1.167-.523-1.167-1.167v-3c0-.644.523-1.167 1.167-1.167h5.667c.643 0 1.166.523 1.166 1.167v5c0 .184-.102.354-.264.441-.074.039-.155.059-.236.059z",
    fill: "#26c6da"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#8ce1eb"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.667,
    cy: 18,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.333,
    cy: 18,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.5 20.667h-3.667c-1.011 0-1.833.822-1.833 1.833v1c0 .276.224.5.5.5h6.333c.276 0 .5-.224.5-.5v-1c0-1.011-.822-1.833-1.833-1.833z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.167 20.667h-3.667c-1.011 0-1.833.822-1.833 1.833v1c0 .276.224.5.5.5h6.333c.276 0 .5-.224.5-.5v-1c0-1.011-.822-1.833-1.833-1.833z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg028Onlinebusiness);
export default __webpack_public_path__ + "static/media/028-online business.a4d8da65e083a4c47c25da9de50c96ec.svg";
export { ForwardRef as ReactComponent };